import { gql } from 'graphql-request';
import { graphQLApi } from 'utils/Api';
import { PayrollGetSalaryResponse, PayrollGetUserSalaryDetailsByIdArgs } from './types';

const getSalaryDetailsQuery = gql`
  query PayrollGetSalaryDetails($userId: String!) {
    payrollGetSalaryDetails(userId: $userId) {
      code
      success
      message
      data {
        id
        organizationId
        salaryModel {
          foodAllowance
          basic
          da
          hra {
            actualHRA
            excessRent
            allowedPercentageOfBasic
            finalExemption
          }
          medicalAllowance
          conveyanceAllowance
          specialAllowance
          lta
          npsEmployerContributionLimit
          npsEmployerContribution
          pf
          allowances {
            name
            amount
            type
          }
          deductions {
            name
            amount
            type
            deductFrom
          }
          totalDeductions
          pfContribution
          esiContribution
          vpf
          overrideIncludeEmployerPfContribution
        }
        isPf
        annualSalary
        customSalaryStructure
        customStructuresAdvisory
        isEmployeeESIContributionEnabled
        flexiPartnerDetails {
          hasOrgOptedForPartnerFlexiBenefit
          flexiPartnerName
          flexiPartnerAllowanceAmount
        }
        variablePay
        perquisitesDetails {
          perquisite
          perquisitesType
          perquisitesWithTypeAndDescription
        }
        loanPerquisiteDetails
        deductibleBenefitsDetails {
          countOfDeductibleBenefits
        }
        isUserAuthorisedToChangeEmployeeSalary
        isEligibleForEmployerESIContribution
        isEligibleForVoluntaryProvidenFund
        isEligibleForEmployerPFContribution
        name
        areThereAnyArrearsPending
        validationErrors
        futureCompensationDate
        futureCompensationAmount
        currentCompensationAmount
        isCombinedSalary
        effectiveFromDate
        ecssProfileDisplayMonth
        upcomingAnnualSalary
        hireDate
        workflowEnabled
        pendingWorkflowRequestExists
        isPayrollBeingFinalized
        isNpsEnabled
      }
    }
  }
`;

export const getSalaryDetails = async (queryVariables: PayrollGetUserSalaryDetailsByIdArgs) => {
  return graphQLApi<PayrollGetSalaryResponse, PayrollGetUserSalaryDetailsByIdArgs>({
    query: getSalaryDetailsQuery,
    queryVariables,
  });
};
export default { getSalaryDetails };
